import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ProgressService} from "./progress.service";
import {AuthenticationService} from "../../authentication/authentication.service";
import {EventService} from "./event.service";
import {ToastrService} from "ngx-toastr";

@Injectable()
export class PermissionService {

    public storage;

    constructor(
        private http: HttpClient,
        private progressService: ProgressService,
        private authenticationService: AuthenticationService,
        private eventService: EventService,
        private ToastrService: ToastrService
    ) {
        this.storage = sessionStorage;
    }


    isConstituentProtectedByAdminUser() {
        return !!this.authenticationService.user.protectedByAdminPassword;
    }

    isSudoerSuperUser() {
        return !!this.authenticationService.sudoer().superUser;
    }

    isApplyAdminProtectionRestrictionsEnabled() {
        if(!!this.eventService.selectedEvent
            && this.eventService.selectedEvent.programGroupName === 'MWOY'
            && this.authenticationService.isImpersonating()
            && !this.storage.getItem("hasValidAdminPassword")) {
            if(this.isConstituentProtectedByAdminUser() && !this.isSudoerSuperUser()) {
                return true;
            }
        }
        if(!!this.eventService.selectedEvent
            && this.eventService.selectedEvent.programGroupName === 'MWOY' &&
            !!this.authenticationService.user && !!this.authenticationService.user.authorities[0]
            && this.authenticationService.user.authorities[0].authority === 'ROLE_ADMIN'
            && !this.storage.getItem("hasValidAdminPassword")) {
            return true;
        }
        return false;
    }

    validateAdminPassword(adminPassword) {
        this.progressService.startProgress(false);
        this.http.post('/api/v1/user/permissions' , adminPassword)
            .subscribe(res => {
                if(res) {
                    this.storage.setItem('hasValidAdminPassword', true);
                } else {
                    this.ToastrService.error("Invalid Admin Password");
                }
                this.progressService.stopProgress(false);
            }, err => {
                this.ToastrService.error("Error validating the admin password");
                this.progressService.stopProgress(false);
            });


    }
}
